import React from "react";

function LightningSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      className={props.className}
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        d="M26.7322 15.6836L12.7322 30.6836C12.5838 30.8419 12.388 30.9477 12.1742 30.985C11.9604 31.0222 11.7404 30.989 11.5472 30.8902C11.354 30.7914 11.1982 30.6325 11.1032 30.4374C11.0083 30.2423 10.9794 30.0216 11.0209 29.8086L12.8534 20.6423L5.64965 17.9373C5.49494 17.8795 5.35697 17.7842 5.24808 17.66C5.13918 17.5358 5.06275 17.3865 5.02561 17.2256C4.98847 17.0646 4.99177 16.897 5.03523 16.7376C5.07869 16.5783 5.16094 16.4321 5.27465 16.3123L19.2747 1.31233C19.423 1.154 19.6188 1.04822 19.8326 1.01096C20.0464 0.973688 20.2664 1.00695 20.4596 1.10574C20.6528 1.20452 20.8086 1.36345 20.9036 1.55856C20.9985 1.75367 21.0274 1.97436 20.9859 2.18733L19.1484 11.3636L26.3521 14.0648C26.5057 14.1231 26.6426 14.2183 26.7506 14.342C26.8587 14.4657 26.9346 14.6141 26.9717 14.7741C27.0087 14.9341 27.0058 15.1008 26.9632 15.2594C26.9205 15.4181 26.8395 15.5637 26.7271 15.6836H26.7322Z"
        fill="#262626"
      />
    </svg>
  );
}

export default LightningSvg;
